import { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "@/lib/api";
import { BRANCH_VIEW_KEY, defaultBranchView } from "@/lib/branchView";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("prism_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("prism_token") && !user) {
      authApi.me().then((r) => setUser(r.data)).catch(() => {});
    }
  }, [user]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await authApi.login(email, password);
      localStorage.setItem("prism_token", data.access_token);
      localStorage.setItem("prism_user", JSON.stringify(data.user));
      // Branch view: Company Admin → All Branches, Branch Admin → own branch (auto-set), others → none.
      const dv = defaultBranchView(data.user);
      if (dv) localStorage.setItem(BRANCH_VIEW_KEY, dv); else localStorage.removeItem(BRANCH_VIEW_KEY);
      setUser(data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("prism_token");
    localStorage.removeItem("prism_user");
    localStorage.removeItem(BRANCH_VIEW_KEY);
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
